module.exports = __webpack_public_path__ + "img/traffic_neo.6d6d13ff.svg";